
export const HOST_NAME = "https://crm.mxd.dk";